import {
  LIST_REPORT4,
  LIST_REPORT4_SUCCESS,
  LIST_REPORT4_CLEAN,
  LIST_REPORT4_ERROR,
} from "./actionTypes"

export const listReport4 = form => ({
  type: LIST_REPORT4,
  payload: { form },
})

export const listReport4Success = report => {
  return {
    type: LIST_REPORT4_SUCCESS,
    payload: { report },
  }
}

export const listReport4Clean = () => {
  return {
    type: LIST_REPORT4_CLEAN,
    payload: {},
  }
}

export const listReport4Error = error => {
  return {
    type: LIST_REPORT4_ERROR,
    payload: error,
  }
}
